import { webatlasTileLayer, WebatlasTileLayerTypes } from 'leaflet-webatlastile';
import L from 'leaflet';

function addMarker(map, latitude, longitude, content) {

    const markerIcon = L.icon({
        iconSize: [25, 41],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40],
        // specify the path here
        iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
        shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
    });

    var marker = L.marker([latitude, longitude], { icon: markerIcon });
    marker.addTo(map);

    var popup = L.popup().setContent(content);
    marker.bindPopup(popup).openPopup();
}

function initializeMap(container, latitude, longitude, zoom) {
    // Create a map
    var map = L.map(
        container,
        { dragging: !L.Browser.mobile, tap: !L.Browser.mobile, fullscreenControl: true }
    ).setView([latitude, longitude], zoom);

    var apiKey = 'B452657B-C6E9-42F0-BCF6-0AB37935A0CC';

    var baseLayers = {
        'Kart': webatlasTileLayer({
            mapType: WebatlasTileLayerTypes.VECTOR,
            apiKey: apiKey
        }),
        'Foto': webatlasTileLayer({
            mapType: WebatlasTileLayerTypes.AERIAL,
            apiKey: apiKey
        }),
        'Hybrid': webatlasTileLayer({
            mapType: WebatlasTileLayerTypes.HYBRID,
            apiKey: apiKey
        }),
        'OpenStreetMap': L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
        }),
    };

    baseLayers[Object.keys(baseLayers)[0]].addTo(map);
    L.control.layers(baseLayers).addTo(map);
    return map;
}

window.initializeMap = initializeMap;
window.addMarker = addMarker;